export default __webpack_public_path__ + "static/simple-doughnut-308fd4973b62549f2b1531330318002d.png";